import React from "react";
import { Users, TrendingUp, Target, Briefcase, Calendar, Award } from "lucide-react";

const stats = [
  { icon: Target, value: "10K+", label: "Leads Generated" },
  { icon: Users, value: "40+", label: "Happy Clients" },
  { icon: TrendingUp, value: "95%", label: "ROI Growth" },
  { icon: Briefcase, value: "50+", label: "Projects Completed" },
  { icon: Calendar, value: "5+", label: "Years Experience" },
  { icon: Award, value: "100%", label: "Client Satisfaction" }
];

function ResultSection() {
  return (
 <section className="relative py-16 px-6 bg-[#f8f8f8] dark:bg-[#050505] overflow-hidden">

    
      {/* BACKGROUND EFFECTS */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      {/* GRID OVERLAY (your same style) */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.05)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[size:70px_70px]" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto">

    <div className="text-center mb-12 md:mb-16">
                  <h2 className="myheading text-3xl md:text-5xl text-center">
                Our Results Speak for {" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
           Themselves
            </span>
          </h2>
   <p className="myparagraph text-gray-500">
Proven performance with real business growth metrics.</p>
      </div>
    

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">

          {stats.map((item, i) => (
            <div
              key={i}
              className="group text-center p-3 rounded-xl bg-white/80 dark:bg-[#111]/80 backdrop-blur-md border border-gray-100 dark:border-gray-800 hover:shadow-lg transition-all duration-300"
            >
              {/* ICON */}
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-orange-50 dark:bg-orange-900/20 mb-3 group-hover:scale-105 transition">
                <item.icon className="w-5 h-5 text-primary" />
              </div>

              {/* VALUE */}
              <h3 className="text-lg md:text-xl font-bold text-gray-900 dark:text-white">
                {item.value}
              </h3>

              {/* LABEL */}
              <p className="text-gray-500 dark:text-gray-400 mt-1 text-[11px] leading-tight">
                {item.label}
              </p>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
}

export default ResultSection;